<ion-modal class="confirmation-modal add-email-modal" #modal backdrop-dismiss="true">
    <ng-template>
        <div class="rounded-2xl bg-white p-4">
            <div class="mb-4 flex items-center justify-between">
                <div class="flex-1 text-center text-base font-bold text-black">
                    {{ 'USER_ADD_EMAIL_INPUT_TITLE' | translate }}
                </div>
                <button class="size-6 p-0" (click)="cancel()" aria-label="{{ 'CLOSE_ARIA_LABEL' | translate }}">
                    <ion-icon class="pb-4 pl-2 text-2xl text-grey-zambezy" name="close"></ion-icon>
                </button>
            </div>

            <form class="space-y-4" [formGroup]="formGroup">
                <mat-form-field class="w-full" appearance="outline">
                    <mat-label>{{ 'PH_EMAIL' | translate }}</mat-label>
                    <input matInput type="email" formControlName="email" required />
                    <mat-error *ngIf="emailInvalid">
                        {{ 'LOCAL_INPUT_VALIDATION_EMAIL' | translate }}
                    </mat-error>
                    <mat-error *ngIf="formGroup.controls.email.hasError('required')">
                        {{ 'LOCAL_INPUT_EMAIL_MISSING' | translate }}
                    </mat-error>
                </mat-form-field>
            </form>

            <div class="mt-4 space-y-2">
                <ion-button
                    class="w-full dark:border-contrast-yellow"
                    [attr.aria-label]="'SUBSCRIBE_TO_NOTIFICATIONS_BTN' | translate"
                    (click)="confirm()"
                    size="large"
                    color="secondary">
                    <ion-label class="whitespace-normal text-sm font-bold normal-case">
                        {{ 'SUBSCRIBE_TO_NOTIFICATIONS_BTN' | translate }}
                    </ion-label>
                </ion-button>
            </div>
        </div>
    </ng-template>
</ion-modal>
